import { Paper, styled } from '@mui/material';
import React from 'react';
import { Outlet } from 'react-router';

const Root = styled('main')(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: 500,
  marginLeft: 'auto',
  marginRight: 'auto',
}));

Root.displayName = 'Root';

const Layout = () => (
  <Root>
    <Paper sx={{ p: 8, textAlign: 'center', width: '100%' }}>
      <Outlet />
    </Paper>
  </Root>
);

export default Layout;
